module.exports = __webpack_public_path__ + "static/img/throttleValveImg.4569717.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/throttleValveImg.png
// module id = DPW5
// module chunks = 1